import {useEffect, useState} from 'react'

import {useForm, useFormState} from 'react-final-form'

import {useFormDirty} from '../../../../contexts/FormDirtyContext'

export const useMeasurementImage = () => {
  const [image, setImage] = useState(undefined)
  const [isNewImage, setIsNewImage] = useState(false)
  const [newImageTemporaryUrl, setNewImageTemporaryUrl] = useState(undefined)
  // mantine core input does not rerender correctly when value is set to undefined (cleared externally),
  // we therefore use a key to force the rerender of the component when the image is deleted
  const [imageKey, setImageKey] = useState(1)

  const form = useForm()
  const {values} = useFormState()
  const initialImage = values?.measuresSection?.measurementImage?.image

  const {hasSavedImage} = useFormDirty()

  const handleImageUpload = (file, onChange) => {
    if (file) {
      const newImage = {
        file,
        imageId: Date.now()
      }
      const objectUrl = URL.createObjectURL(newImage.file)
      setIsNewImage(true)

      setImage(newImage)

      setNewImageTemporaryUrl(objectUrl)
      onChange(file)
    }
  }

  const handleDeleteImageClick = () => {
    const imageId = initialImage ? initialImage.imageId : image.imageId
    if (hasSavedImage) {
      form.change('measuresSection.measurementImage', {
        delete: true,
        imageId: imageId
      })
    } else {
      form.change('measuresSection', {
        ...form.getState().values.measuresSection,
        measurementImage: undefined
      })
    }

    setImageKey(prevKey => prevKey + 1)
    setIsNewImage(false)
    setNewImageTemporaryUrl(undefined)
  }

  const renderImageUrl = () => {
    const imageURL = isNewImage
      ? newImageTemporaryUrl
      : `${window.env.REACT_APP_API_FILES}/products/${initialImage?.filename}`

    return imageURL
  }

  useEffect(() => {
    return () => {
      if (newImageTemporaryUrl) {
        URL.revokeObjectURL(newImageTemporaryUrl)
      }
    }
  }, [newImageTemporaryUrl])

  return {
    handleImageUpload,
    image,
    initialImage,
    handleDeleteImageClick,
    newImageTemporaryUrl,
    imageKey,
    isNewImage,
    renderImageUrl
  }
}
